import React, { useEffect, useRef, useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import {
  HomeFavourite,
  HomeFooterPlatform,
  HomeIcon,
  HomeTabData,
} from "./casino/ListHome";
import { isMobile } from "react-device-detect";
import { isEmpty, startCase, upperCase } from "lodash";
import { toast } from "react-toastify";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import referralIcon from "../assets/images/icon-referral.svg";
import Draggable from "react-draggable";
const CARD_TRIANGLE_URL =
  'url("/assets/card-triangle.svg")';

const Sports = () => {
  const homeTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.homeTab;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const navigate = useNavigate();
  const object = HomeIcon;
  const setHomeTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setHomeTab;
  });
  const setCasinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoBefore;
  });
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const navRef = useRef(null);
  const navInitialTop = useRef(null);
  const [navIsSticky, setNavIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!navRef.current) return;

      // Get the header height (the header element at the top)
      const header = document.querySelector("header");
      const headerHeight = header ? header.offsetHeight : 0;

      // Capture the initial top position of the nav on first call
      if (navInitialTop.current === null) {
        navInitialTop.current =
          navRef.current.getBoundingClientRect().top + window.scrollY;
      }

      // Check if the user has scrolled past the nav's original position minus the header height
      if (window.scrollY >= navInitialTop.current - headerHeight) {
        setNavIsSticky(true);
      } else {
        setNavIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run once on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error(t("ComingSoon"));
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
            isLobbyTrue: res?.isLobbyTrue,
          });
        }
      }
    } else {
      setCasinoBefore(true);
    }
  };
  const handle = (value) => {
    setHomeTab(value);
    setTimeout(() => {
      if (navRef.current) {
        const activeBtn = navRef.current.querySelector(`[data-tab="${value}"]`);
        if (activeBtn) {
          activeBtn.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start",
          });
        }
      }
    }, 50);
  };

  const tabList = [
    "hot",
    "sports",
    "casino",
    "slots",
    "crash",
    "table",
    "fishing",
    "arcade",
    "lottery",
  ];
  const getTranslateIndex = (tab) => {
    return tabList.indexOf(tab);
  };

  const getTranslateX = (tab) => {
    const index = tabList.indexOf(tab);
    return index === -1 ? 0 : index * -100;
  };
  const navContentRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const startTranslateX = useRef(0);
  const currentTranslateX = useRef(getTranslateX(homeTab));

  // Keep currentTranslateX in sync when tab changes via click
  useEffect(() => {
    currentTranslateX.current = getTranslateX(homeTab);
  }, [homeTab]);

  const [bannerData, setBannerData] = useState([]);
  const getBannerData = async (userId = "") => {
    const { status, data } = await apiPost(apiPath.getBanner, {
      type: "home_mid",
      // user_id: userId,
    });

    if (status === 200 && data?.success) {
      setBannerData(data?.results?.banners);
    }
  };
  useEffect(() => {
    getBannerData(user?.user?._id || "");
  }, []);
  const handelShowReferBox = useContextSelector(
    AuthContext,
    (ctx) => ctx.handelShowReferBox,
  );
  const nodeRef = useRef(null);

  const [startX1, setStartX] = useState(null);
  const [startY1, setStartY] = useState(null);

  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    setStartX(touch.clientX);
    setStartY(touch.clientY);
  };

  const handleTouchEnd = (event) => {
    const touch = event.changedTouches[0];

    const endX = touch.clientX;
    const endY = touch.clientY;

    const distance = Math.sqrt((endX - startX1) ** 2 + (endY - startY1) ** 2);

    if (distance < 5) {
      handelShowReferBox();
    }
    console.log(distance);
  };

  return (
    <>
      <mcd-game-nav-icon-inner
        _ngcontent-serverapp-c2491258092
        _nghost-serverapp-c1656637286
      >
        <div
          ref={navRef}
          _ngcontent-serverapp-c1656637286
          id="nav"
          className={`nav nav-category ng-star-inserted nav-auto${navIsSticky ? " active" : ""}`}
          style={{ overflowX: "auto", scrollBehavior: "smooth" }}
        >
          <div
            data-tab="hot"
            onClick={() => handle("hot")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "hot" ? "slick-current slick-active" : ""}`}
          >
            <span
              _ngcontent-serverapp-c1656637286
              className={homeTab == "hot" ? "active" : ""}
              style={{
                "mask-image":
                  'url("/assets/Other/icon-hotgame.webp?v=1772072361392")',
              }}
            />
            <p _ngcontent-serverapp-c1656637286>{t("HOT")}</p>
          </div>
          <div
            data-tab="sports"
            onClick={() => handle("sports")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "sports" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-sport.webp?v=1772072361392")',
              }}
              className={homeTab == "sports" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Sports")}</p>
          </div>
          <div
            data-tab="casino"
            onClick={() => handle("casino")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "casino" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-casino.webp?v=1772072361392")',
              }}
              className={homeTab == "casino" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Casino")}</p>
          </div>
          <div
            data-tab="slots"
            onClick={() => handle("slots")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "slots" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-slot.webp?v=1772072361392")',
              }}
              className={homeTab == "slots" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Slots")}</p>
          </div>
          <div
            data-tab="crash"
            onClick={() => handle("crash")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "crash" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-crash.webp?v=1772072361392")',
              }}
              className={homeTab == "crash" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Crash")}</p>
          </div>
          <div
            data-tab="table"
            onClick={() => handle("table")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "table" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-table.webp?v=1772072361392")',
              }}
              className={homeTab == "table" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Table")}</p>
          </div>
          <div
            data-tab="fishing"
            onClick={() => handle("fishing")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "fishing" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-fish.webp?v=1772072361392")',
              }}
              className={homeTab == "fishing" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Fishing")}</p>
          </div>
          <div
            data-tab="arcade"
            onClick={() => handle("arcade")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "arcade" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-arcade.webp?v=1772072361392")',
              }}
              className={homeTab == "arcade" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Arcade")}</p>
          </div>
          <div
            data-tab="lottery"
            onClick={() => handle("lottery")}
            _ngcontent-serverapp-c1656637286
            className={`btn slick-slide ng-star-inserted ${homeTab == "lottery" ? "slick-current slick-active" : ""}`}
            data-category-type-id={0}
            data-tab-current
          >
            <span
              _ngcontent-serverapp-c1656637286
              style={{
                "mask-image":
                  'url("/assets/Other/icon-lottery.webp?v=1772072361392")',
              }}
              className={homeTab == "lottery" ? "active" : ""}
            />
            <p _ngcontent-serverapp-c1656637286>{t("Lotto")}</p>
          </div>
        </div>

        <div
          style={{ paddingTop: "10px" }}
          _ngcontent-serverapp-c1656637286
          className="nav-wrap ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c1312296706
            id="nav-title"
            className="content-title"
          >
            <h2 _ngcontent-serverapp-c1312296706 className="ng-star-inserted">
              <span
                _ngcontent-serverapp-c1312296706
                className="ng-star-inserted"
              >
                {upperCase(homeTab)}
              </span>
            </h2>
          </div>
          <div
            ref={navContentRef}
            _ngcontent-serverapp-c1656637286
            className="nav-content-wrap"
            style={{
              cursor: isDragging.current ? "grabbing" : "grab",
              overflow: "hidden",
            }}
            onMouseDown={(e) => {
              isDragging.current = true;
              startX.current = e.clientX;
              startTranslateX.current = currentTranslateX.current;
              e.preventDefault();
            }}
            onMouseMove={(e) => {
              if (!isDragging.current) return;
              const delta = e.clientX - startX.current;
              const containerWidth = navContentRef.current?.offsetWidth || 1;
              const deltaPercent = (delta / containerWidth) * 100;
              const newTranslate = startTranslateX.current + deltaPercent;

              // Clamp between 0 and -(tabList.length - 1) * 100
              const clamped = Math.min(
                0,
                Math.max(-(tabList.length - 1) * 100, newTranslate),
              );
              currentTranslateX.current = clamped;

              const inner =
                navContentRef.current?.querySelector(".nav-content-inner");
              if (inner) {
                inner.style.transform = `translate(${clamped}%, 0px)`;
                inner.style.transition = "none"; // Remove transition while dragging
              }
            }}
            onMouseUp={(e) => {
              if (!isDragging.current) return;
              isDragging.current = false;

              const delta = e.clientX - startX.current;
              const containerWidth = navContentRef.current?.offsetWidth || 1;
              const deltaPercent = (delta / containerWidth) * 100;

              // Snap to nearest tab
              const rawIndex = -startTranslateX.current / 100;
              const draggedIndex = rawIndex - deltaPercent / 100;
              const snappedIndex = Math.round(
                Math.max(0, Math.min(tabList.length - 1, draggedIndex)),
              );

              const snappedTab = tabList[snappedIndex];
              currentTranslateX.current = snappedIndex * -100;

              // Restore transition and snap
              const inner =
                navContentRef.current?.querySelector(".nav-content-inner");
              if (inner) {
                inner.style.transition = "transform 0.4s ease-in-out";
                inner.style.transform = `translate(${snappedIndex * -100}%, 0px)`;
              }

              setHomeTab(snappedTab);
            }}
            onMouseLeave={() => {
              if (!isDragging.current) return;
              isDragging.current = false;

              const inner =
                navContentRef.current?.querySelector(".nav-content-inner");
              if (inner) {
                inner.style.transition = "transform 0.4s ease-in-out";
                inner.style.transform = `translate(${currentTranslateX.current}%, 0px)`;
              }
            }}
            // Touch support
            onTouchStart={(e) => {
              isDragging.current = true;
              startX.current = e.touches[0].clientX;
              startTranslateX.current = currentTranslateX.current;
            }}
            onTouchMove={(e) => {
              if (!isDragging.current) return;
              const delta = e.touches[0].clientX - startX.current;
              const containerWidth = navContentRef.current?.offsetWidth || 1;
              const deltaPercent = (delta / containerWidth) * 100;
              const newTranslate = startTranslateX.current + deltaPercent;
              const clamped = Math.min(
                0,
                Math.max(-(tabList.length - 1) * 100, newTranslate),
              );
              currentTranslateX.current = clamped;

              const inner =
                navContentRef.current?.querySelector(".nav-content-inner");
              if (inner) {
                inner.style.transform = `translate(${clamped}%, 0px)`;
                inner.style.transition = "none";
              }
            }}
            onTouchEnd={(e) => {
              isDragging.current = false;
              const delta = e.changedTouches[0].clientX - startX.current;
              const containerWidth = navContentRef.current?.offsetWidth || 1;
              const deltaPercent = (delta / containerWidth) * 100;

              const rawIndex = -startTranslateX.current / 100;
              const draggedIndex = rawIndex - deltaPercent / 100;
              const snappedIndex = Math.round(
                Math.max(0, Math.min(tabList.length - 1, draggedIndex)),
              );
              const snappedTab = tabList[snappedIndex];
              currentTranslateX.current = snappedIndex * -100;

              const inner =
                navContentRef.current?.querySelector(".nav-content-inner");
              if (inner) {
                inner.style.transition = "transform 0.4s ease-in-out";
                inner.style.transform = `translate(${snappedIndex * -100}%, 0px)`;
              }

              setHomeTab(snappedTab);
            }}
          >
            <div
              _ngcontent-serverapp-c1656637286
              className="nav-content-inner"
              style={{
                "-webkit-transform": `translate(${getTranslateX(homeTab)}%, 0px)`,
                "-ms-transform": `translate(${getTranslateX(homeTab)}%, 0px)`,
                transform: `translate(${getTranslateX(homeTab)}%, 0px)`,
                transition: "transform 0.4s ease-in-out",
              }}
            >
              {tabList.map((tab, tabIndex) => (
                <div
                  key={tab}
                  _ngcontent-serverapp-c1656637286
                  className="content-box ng-star-inserted"
                  style={
                    getTranslateIndex(homeTab) === tabIndex
                      ? {}
                      : { maxHeight: "0" }
                  }
                >
                  <mcd-game-layout
                    _ngcontent-serverapp-c1656637286
                    _nghost-serverapp-c2128540548
                  >
                    <div
                      _ngcontent-serverapp-c2128540548
                      className="layout-brand"
                    >
                      <div
                        _ngcontent-serverapp-c2128540548
                        className="card1 icon mobile"
                      >
                        <ul _ngcontent-serverapp-c2128540548>
                          {(HomeTabData[tab] || []).map((item, index) => (
                            <li
                              onClick={() => {
                                if (homeTab == "hot") {
                                  handel(item);
                                } else {
                                  if (homeTab == "sports") {
                                    if (item?.name == "Velki") {
                                      if (isEmpty(user)) {
                                        setCasinoBefore(true);
                                      } else {
                                        navigate("/sports-velki");
                                      }
                                    } else if (item?.name == "9wickets") {
                                      if (isEmpty(user)) {
                                        setCasinoBefore(true);
                                      } else {
                                        if (isMobile) {
                                          navigate("/inplay-sky");
                                        } else {
                                          navigate("/sports-sky");
                                        }
                                      }
                                    } else {
                                      handel(item);
                                    }
                                  } else {
                                    navigate(
                                      `/casino?type=${homeTab}&provider=${item?.vendor}`,
                                    );
                                  }
                                }
                              }}
                              key={`${tab}-${index}`}
                              _ngcontent-serverapp-c2128540548
                              web-category-type={item.categoryType}
                              game-type={item.gameType}
                              {...(item.vendorCode
                                ? { "vendor-code": item.vendorCode }
                                : {})}
                              className="ng-star-inserted"
                            >
                              <span
                                _ngcontent-serverapp-c2128540548
                                className="ng-star-inserted"
                                style={{
                                  "background-image": CARD_TRIANGLE_URL,
                                }}
                              />

                              <a
                                _ngcontent-serverapp-c2128540548
                                tabIndex={-1}
                                mcdneuaclick=""
                                {...(item.vendor
                                  ? { vendor: item.vendor }
                                  : {})}
                              >
                                <img
                                  _ngcontent-serverapp-c2128540548
                                  {...(item.alt ? { alt: item.alt } : {})}
                                  src={item.src || item?.image}
                                  {...(item.alt ? { loading: "lazy" } : {})}
                                  className="ng-star-inserted"
                                />

                                <p
                                  _ngcontent-serverapp-c2128540548
                                  className="ng-star-inserted"
                                >
                                  {item.name}
                                </p>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </mcd-game-layout>
                </div>
              ))}
            </div>
          </div>
        </div>
      </mcd-game-nav-icon-inner>{" "}
      {bannerData?.length > 0 && isMobile && (
        <div
          _ngcontent-serverapp-c29461739
          className="recommend scroll-banner ng-star-inserted"
        >
          <div _ngcontent-serverapp-c29461739 className="recommend-title">
            <h2 _ngcontent-serverapp-c29461739>Favourites</h2>
          </div>
          <div _ngcontent-serverapp-c29461739 className="recommend-bg">
            <div _ngcontent-serverapp-c29461739 className="recommend-main">
              {bannerData?.map((res) => {
                return (
                  <div
                    _ngcontent-serverapp-c29461739
                    className="recommend-card ng-star-inserted"
                  >
                    <a href="#" _ngcontent-serverapp-c29461739>
                      <img
                        _ngcontent-serverapp-c29461739
                        fetchpriority="high"
                        alt="image_313820"
                        src={
                          process.env.REACT_APP_API_BASE_URL + res.banner_path
                        }
                        loading="lazy"
                      />
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {/* {!isEmpty(user) && (
        <Draggable
          nodeRef={nodeRef}
          onStart={handleTouchStart}
          onStop={handleTouchEnd}
        >
          <div
            ref={nodeRef}
            className="refer-box blinkreace"
            onClick={() => handelShowReferBox()}
          >
            <img src={referralIcon} style={{ width: "19px" }} />
            Refer
          </div>
        </Draggable>
      )} */}
      <div
        _ngcontent-serverapp-c185242981
        className="recommend ng-star-inserted"
      >
        <div _ngcontent-serverapp-c185242981 className="recommend-title">
          <h2 _ngcontent-serverapp-c185242981>{t("PopularGames")}</h2>
        </div>
        <div _ngcontent-serverapp-c185242981 className="recommend-bg games">
          <div
            _ngcontent-serverapp-c185242981
            className="recommend-main games-main"
          >
            {HomeFavourite?.map((res) => {
              return (
                <div
                  onClick={() => handel(res)}
                  _ngcontent-serverapp-c185242981
                  className="games-box ng-star-inserted"
                >
                  <div _ngcontent-serverapp-c185242981 className="pic">
                    <a _ngcontent-serverapp-c185242981 helf="#">
                      <img
                        _ngcontent-serverapp-c185242981
                        alt={res?.name}
                        src={res?.image}
                        loading="lazy"
                      />
                    </a>
                  </div>
                  <div _ngcontent-serverapp-c185242981 className="text">
                    <h3 _ngcontent-serverapp-c185242981>{res?.name}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sports;
